import axiosInstance from "../helpers/axios";
import toast from "react-hot-toast";
import {
  countryConstants,
  warehouseConstants,
  shippingCompanyConstants,
  priceConstants,
  shippingCategoryConstants,
} from "./constants";

// ─── Country ──────────────────────────────────────────────────────────────────

export const getAllCountries = () => async (dispatch) => {
  dispatch({ type: countryConstants.GET_COUNTRIES_REQUEST });
  try {
    const res = await axiosInstance.get("/shipping/get-countries");
    if (res.status === 200) {
      dispatch({
        type: countryConstants.GET_COUNTRIES_SUCCESS,
        payload: { countries: res.data.countries },
      });
    } else {
      dispatch({
        type: countryConstants.GET_COUNTRIES_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    dispatch({
      type: countryConstants.GET_COUNTRIES_FAILURE,
      payload: { error: error.message },
    });
  }
};

export const createCountry = (form) => async (dispatch) => {
  dispatch({ type: countryConstants.CREATE_COUNTRY_REQUEST });
  try {
    const res = await axiosInstance.post(
      "/admin/shipping/create-country",
      form,
    );
    if (res.status === 201) {
      dispatch({
        type: countryConstants.CREATE_COUNTRY_SUCCESS,
        payload: { country: res.data.country },
      });
      toast.success("Country created successfully");
    } else {
      dispatch({
        type: countryConstants.CREATE_COUNTRY_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    const data = error?.response?.data;
    dispatch({
      type: countryConstants.CREATE_COUNTRY_FAILURE,
      payload: { error: error.message },
    });
    toast.error(data?.msg || "Error creating country");
  }
};

export const updateCountry = (id, form) => async (dispatch) => {
  dispatch({ type: countryConstants.UPDATE_COUNTRY_REQUEST });
  try {
    const res = await axiosInstance.put(
      `/admin/shipping/update-country/${id}`,
      form,
    );
    if (res.status === 200) {
      dispatch({
        type: countryConstants.UPDATE_COUNTRY_SUCCESS,
        payload: { country: res.data.country },
      });
      toast.success("Country updated successfully");
    } else {
      dispatch({
        type: countryConstants.UPDATE_COUNTRY_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    const data = error?.response?.data;
    dispatch({
      type: countryConstants.UPDATE_COUNTRY_FAILURE,
      payload: { error: error.message },
    });
    toast.error(data?.msg || "Error updating country");
  }
};

export const deleteCountry = (id) => async (dispatch) => {
  dispatch({ type: countryConstants.DELETE_COUNTRY_REQUEST });
  try {
    const res = await axiosInstance.delete(
      `/admin/shipping/delete-country/${id}`,
    );
    if (res.status === 200) {
      dispatch({
        type: countryConstants.DELETE_COUNTRY_SUCCESS,
        payload: { id },
      });
      toast.success("Country deleted successfully");
    } else {
      dispatch({
        type: countryConstants.DELETE_COUNTRY_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    const data = error?.response?.data;
    dispatch({
      type: countryConstants.DELETE_COUNTRY_FAILURE,
      payload: { error: error.message },
    });
    toast.error(data?.msg || "Error deleting country");
  }
};

// ─── Warehouse ────────────────────────────────────────────────────────────────

export const getAllWarehouses = () => async (dispatch) => {
  dispatch({ type: warehouseConstants.GET_WAREHOUSES_REQUEST });
  try {
    const res = await axiosInstance.get("/admin/shipping/get-warehouses");
    if (res.status === 200) {
      dispatch({
        type: warehouseConstants.GET_WAREHOUSES_SUCCESS,
        payload: { warehouses: res.data.warehouses },
      });
    } else {
      dispatch({
        type: warehouseConstants.GET_WAREHOUSES_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    dispatch({
      type: warehouseConstants.GET_WAREHOUSES_FAILURE,
      payload: { error: error.message },
    });
  }
};

export const createWarehouse = (form) => async (dispatch) => {
  dispatch({ type: warehouseConstants.CREATE_WAREHOUSE_REQUEST });
  try {
    const res = await axiosInstance.post(
      "/admin/shipping/create-warehouse",
      form,
    );
    if (res.status === 201) {
      dispatch({
        type: warehouseConstants.CREATE_WAREHOUSE_SUCCESS,
        payload: { warehouse: res.data.warehouse },
      });
      toast.success("Warehouse created successfully");
    } else {
      dispatch({
        type: warehouseConstants.CREATE_WAREHOUSE_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    const data = error?.response?.data;
    dispatch({
      type: warehouseConstants.CREATE_WAREHOUSE_FAILURE,
      payload: { error: error.message },
    });
    toast.error(data?.msg || "Error creating warehouse");
  }
};

export const updateWarehouse = (id, form) => async (dispatch) => {
  dispatch({ type: warehouseConstants.UPDATE_WAREHOUSE_REQUEST });
  try {
    const res = await axiosInstance.put(
      `/admin/shipping/update-warehouse/${id}`,
      form,
    );
    if (res.status === 200) {
      dispatch({
        type: warehouseConstants.UPDATE_WAREHOUSE_SUCCESS,
        payload: { warehouse: res.data.warehouse },
      });
      toast.success("Warehouse updated successfully");
    } else {
      dispatch({
        type: warehouseConstants.UPDATE_WAREHOUSE_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    const data = error?.response?.data;
    dispatch({
      type: warehouseConstants.UPDATE_WAREHOUSE_FAILURE,
      payload: { error: error.message },
    });
    toast.error(data?.msg || "Error updating warehouse");
  }
};

export const deleteWarehouse = (id) => async (dispatch) => {
  dispatch({ type: warehouseConstants.DELETE_WAREHOUSE_REQUEST });
  try {
    const res = await axiosInstance.delete(
      `/admin/shipping/delete-warehouse/${id}`,
    );
    if (res.status === 200) {
      dispatch({
        type: warehouseConstants.DELETE_WAREHOUSE_SUCCESS,
        payload: { id },
      });
      toast.success("Warehouse deleted successfully");
    } else {
      dispatch({
        type: warehouseConstants.DELETE_WAREHOUSE_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    const data = error?.response?.data;
    dispatch({
      type: warehouseConstants.DELETE_WAREHOUSE_FAILURE,
      payload: { error: error.message },
    });
    toast.error(data?.msg || "Error deleting warehouse");
  }
};

// ─── Shipping Company ─────────────────────────────────────────────────────────

export const getAllShippingCompanies = () => async (dispatch) => {
  dispatch({ type: shippingCompanyConstants.GET_SHIPPING_COMPANIES_REQUEST });
  try {
    const res = await axiosInstance.get("/admin/shipping/get-companies");
    if (res.status === 200) {
      dispatch({
        type: shippingCompanyConstants.GET_SHIPPING_COMPANIES_SUCCESS,
        payload: { companies: res.data.companies },
      });
    } else {
      dispatch({
        type: shippingCompanyConstants.GET_SHIPPING_COMPANIES_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    dispatch({
      type: shippingCompanyConstants.GET_SHIPPING_COMPANIES_FAILURE,
      payload: { error: error.message },
    });
  }
};

export const createShippingCompany = (form) => async (dispatch) => {
  dispatch({ type: shippingCompanyConstants.CREATE_SHIPPING_COMPANY_REQUEST });
  try {
    const res = await axiosInstance.post(
      "/admin/shipping/create-company",
      form,
    );
    if (res.status === 201) {
      dispatch({
        type: shippingCompanyConstants.CREATE_SHIPPING_COMPANY_SUCCESS,
        payload: { company: res.data.company },
      });
      toast.success("Shipping company created successfully");
    } else {
      dispatch({
        type: shippingCompanyConstants.CREATE_SHIPPING_COMPANY_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    const data = error?.response?.data;
    dispatch({
      type: shippingCompanyConstants.CREATE_SHIPPING_COMPANY_FAILURE,
      payload: { error: error.message },
    });
    toast.error(data?.msg || "Error creating shipping company");
  }
};

export const updateShippingCompany = (id, form) => async (dispatch) => {
  dispatch({ type: shippingCompanyConstants.UPDATE_SHIPPING_COMPANY_REQUEST });
  try {
    const res = await axiosInstance.put(
      `/admin/shipping/update-company/${id}`,
      form,
    );
    if (res.status === 200) {
      dispatch({
        type: shippingCompanyConstants.UPDATE_SHIPPING_COMPANY_SUCCESS,
        payload: { company: res.data.company },
      });
      toast.success("Shipping company updated successfully");
    } else {
      dispatch({
        type: shippingCompanyConstants.UPDATE_SHIPPING_COMPANY_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    const data = error?.response?.data;
    dispatch({
      type: shippingCompanyConstants.UPDATE_SHIPPING_COMPANY_FAILURE,
      payload: { error: error.message },
    });
    toast.error(data?.msg || "Error updating shipping company");
  }
};

export const deleteShippingCompany = (id) => async (dispatch) => {
  dispatch({ type: shippingCompanyConstants.DELETE_SHIPPING_COMPANY_REQUEST });
  try {
    const res = await axiosInstance.delete(
      `/admin/shipping/delete-company/${id}`,
    );
    if (res.status === 200) {
      dispatch({
        type: shippingCompanyConstants.DELETE_SHIPPING_COMPANY_SUCCESS,
        payload: { id },
      });
      toast.success("Shipping company deleted successfully");
    } else {
      dispatch({
        type: shippingCompanyConstants.DELETE_SHIPPING_COMPANY_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    const data = error?.response?.data;
    dispatch({
      type: shippingCompanyConstants.DELETE_SHIPPING_COMPANY_FAILURE,
      payload: { error: error.message },
    });
    toast.error(data?.msg || "Error deleting shipping company");
  }
};

// ─── Price ────────────────────────────────────────────────────────────────────

export const getPricesByCompany = (companyId) => async (dispatch) => {
  dispatch({ type: priceConstants.GET_PRICES_REQUEST });
  try {
    const res = await axiosInstance.get(
      `/admin/shipping/get-prices/${companyId}`,
    );
    if (res.status === 200) {
      dispatch({
        type: priceConstants.GET_PRICES_SUCCESS,
        payload: { prices: res.data.prices },
      });
    } else {
      dispatch({
        type: priceConstants.GET_PRICES_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    dispatch({
      type: priceConstants.GET_PRICES_FAILURE,
      payload: { error: error.message },
    });
  }
};

export const createPrice = (form) => async (dispatch) => {
  dispatch({ type: priceConstants.CREATE_PRICE_REQUEST });
  try {
    const res = await axiosInstance.post("/admin/shipping/create-price", form);
    if (res.status === 201) {
      dispatch({
        type: priceConstants.CREATE_PRICE_SUCCESS,
        payload: { price: res.data.price },
      });
      toast.success("Price created successfully");
    } else {
      dispatch({
        type: priceConstants.CREATE_PRICE_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    const data = error?.response?.data;
    dispatch({
      type: priceConstants.CREATE_PRICE_FAILURE,
      payload: { error: error.message },
    });
    toast.error(data?.msg || "Error creating price");
  }
};

export const updatePrice = (id, form) => async (dispatch) => {
  dispatch({ type: priceConstants.UPDATE_PRICE_REQUEST });
  try {
    const res = await axiosInstance.put(
      `/admin/shipping/update-price/${id}`,
      form,
    );
    if (res.status === 200) {
      dispatch({
        type: priceConstants.UPDATE_PRICE_SUCCESS,
        payload: { price: res.data.price },
      });
      toast.success("Price updated successfully");
    } else {
      dispatch({
        type: priceConstants.UPDATE_PRICE_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    const data = error?.response?.data;
    dispatch({
      type: priceConstants.UPDATE_PRICE_FAILURE,
      payload: { error: error.message },
    });
    toast.error(data?.msg || "Error updating price");
  }
};

export const deletePrice = (id) => async (dispatch) => {
  dispatch({ type: priceConstants.DELETE_PRICE_REQUEST });
  try {
    const res = await axiosInstance.delete(
      `/admin/shipping/delete-price/${id}`,
    );
    if (res.status === 200) {
      dispatch({
        type: priceConstants.DELETE_PRICE_SUCCESS,
        payload: { id },
      });
      toast.success("Price deleted successfully");
    } else {
      dispatch({
        type: priceConstants.DELETE_PRICE_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    const data = error?.response?.data;
    dispatch({
      type: priceConstants.DELETE_PRICE_FAILURE,
      payload: { error: error.message },
    });
    toast.error(data?.msg || "Error deleting price");
  }
};

// ─── Shipping Category ────────────────────────────────────────────────────────

export const getAllShippingCategories = (page, limit) => async (dispatch) => {
  dispatch({ type: shippingCategoryConstants.GET_SHIPPING_CATEGORIES_REQUEST });
  try {
    const res = await axiosInstance.get(
      `/admin/shipping/get-categories?page=${page}&limit=${limit}`,
    );
    if (res.status === 200) {
      dispatch({
        type: shippingCategoryConstants.GET_SHIPPING_CATEGORIES_SUCCESS,
        payload: {
          shippingCategories: res.data.categories,
          pagination: res.data.pagination,
        },
      });
    } else {
      dispatch({
        type: shippingCategoryConstants.GET_SHIPPING_CATEGORIES_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    dispatch({
      type: shippingCategoryConstants.GET_SHIPPING_CATEGORIES_FAILURE,
      payload: { error: error.message },
    });
  }
};

export const createShippingCategory = (form) => async (dispatch) => {
  dispatch({
    type: shippingCategoryConstants.CREATE_SHIPPING_CATEGORY_REQUEST,
  });
  try {
    const res = await axiosInstance.post(
      "/admin/shipping/create-category",
      form,
    );
    if (res.status === 201) {
      dispatch({
        type: shippingCategoryConstants.CREATE_SHIPPING_CATEGORY_SUCCESS,
        payload: { shippingCategory: res.data.category },
      });
      toast.success("Shipping category created successfully");
    } else {
      dispatch({
        type: shippingCategoryConstants.CREATE_SHIPPING_CATEGORY_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    const data = error?.response?.data;
    dispatch({
      type: shippingCategoryConstants.CREATE_SHIPPING_CATEGORY_FAILURE,
      payload: { error: error.message },
    });
    toast.error(data?.msg || "Error creating shipping category");
  }
};

export const updateShippingCategory = (id, form) => async (dispatch) => {
  dispatch({
    type: shippingCategoryConstants.UPDATE_SHIPPING_CATEGORY_REQUEST,
  });
  try {
    const res = await axiosInstance.put(
      `/admin/shipping/update-category/${id}`,
      form,
    );
    if (res.status === 200) {
      dispatch({
        type: shippingCategoryConstants.UPDATE_SHIPPING_CATEGORY_SUCCESS,
        payload: { shippingCategory: res.data.category },
      });
      toast.success("Shipping category updated successfully");
    } else {
      dispatch({
        type: shippingCategoryConstants.UPDATE_SHIPPING_CATEGORY_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    const data = error?.response?.data;
    dispatch({
      type: shippingCategoryConstants.UPDATE_SHIPPING_CATEGORY_FAILURE,
      payload: { error: error.message },
    });
    toast.error(data?.msg || "Error updating shipping category");
  }
};

export const deleteShippingCategory = (id) => async (dispatch) => {
  dispatch({
    type: shippingCategoryConstants.DELETE_SHIPPING_CATEGORY_REQUEST,
  });
  try {
    const res = await axiosInstance.delete(
      `/admin/shipping/delete-category/${id}`,
    );
    if (res.status === 200) {
      dispatch({
        type: shippingCategoryConstants.DELETE_SHIPPING_CATEGORY_SUCCESS,
        payload: { id },
      });
      toast.success("Shipping category deleted successfully");
    } else {
      dispatch({
        type: shippingCategoryConstants.DELETE_SHIPPING_CATEGORY_FAILURE,
        payload: { error: res.data.error },
      });
    }
  } catch (error) {
    const data = error?.response?.data;
    dispatch({
      type: shippingCategoryConstants.DELETE_SHIPPING_CATEGORY_FAILURE,
      payload: { error: error.message },
    });
    toast.error(data?.msg || "Error deleting shipping category");
  }
};
